/**
 * @typedef { import('../time.js').YearMonthPeriod } YearMonthPeriod
 * @typedef { import('../time.js').YearMonthPeriodObject } YearMonthPeriodObject
 */

import {convertObjectToYearMonthPeriod} from '../time.js';

//-----------------------------------------------------------------------------

export class PlayerRevenueReport {
  /**
   * @param {YearMonthPeriod} period
   * @param {PlayerRevenueInfo[]} players
   */
  constructor(period, players) {
    this.period = period;
    this.players = players;
  }

  getPeriod() {
    return this.period;
  }

  getPlayers() {
    return this.players;
  }
}

/**
 * @typedef {Object} PlayerRevenueReportObject
 * @property {YearMonthPeriodObject} period
 * @property {PlayerRevenueInfo[]} players
 */

/**
 * @param {PlayerRevenueReportObject} reportObject 
 * @returns {?PlayerRevenueReport}
 */
export function convertObjectToPlayerRevenueReport(reportObject) {
  const period = convertObjectToYearMonthPeriod(reportObject.period);
  if(period === null) {
    return null;
  }

  const players = reportObject.players;

  return new PlayerRevenueReport(period, players);
}

/**
 * @param {PlayerRevenueReport} report
 * @returns {string}
 */
export function convertPlayerRevenueReportToString(report) {
  let str = "player_id,revenue\n";

  for(const player of report.getPlayers()) {
    str += `${player.id},${player.revenue}\n`;
  }
  return str
}

//-----------------------------------------------------------------------------

/**
 * @typedef {Object} PlayerRevenueInfo
 * @property {number} id
 * @property {number} revenue
 */
